import { Icon } from "@circle-react-shared/Icon";
import { Characteristics } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Characteristics";
import { Community } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Community";
import { Heading } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Heading";
import { LiveStreams } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/LiveStreams";
import { Services } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Services";
import { Sso } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Sso";
import { Support } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Support";
import { Workflows } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Workflows";
import { useState } from "react";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { AddOns } from "@/react/components/SettingsApp/Plan/RegularPlan/Features/Addons";
import { AiFeatures } from "@/react/components/SettingsApp/Plan/RegularPlan/Features/AiFeatures";
import { ApiAddons } from "@/react/components/SettingsApp/Plan/RegularPlan/Features/ApiAddons";
import { BrandedApps } from "@/react/components/SettingsApp/Plan/RegularPlan/Features/BrandedApps";

import { TierHeaders } from "./TierHeaders";

const Features = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="hidden sm:block">
      <div className="flex justify-center">
        <Button
          variant="secondary"
          onClick={() => setIsExpanded(prev => !prev)}
          className="mb-6 !text-md"
          aria-expanded={isExpanded}
          aria-controls="features-content"
          large
        >
          {t("pricing_plans.plan_settings.plan_selection.features.toggle_text")}
          <Icon
            type={isExpanded ? "20-chevron-up" : "20-chevron-down"}
            className="ml-1"
          />
        </Button>
      </div>
      {isExpanded && (
        <div id="features-content">
          <Heading>
            {t("pricing_plans.plan_settings.plan_selection.features.title")}
          </Heading>
          <TierHeaders />
          <Community />
          <Workflows />
          <LiveStreams />
          <Characteristics />
          <AiFeatures />
          <BrandedApps />
          <ApiAddons />
          <Heading>{t("settings.billing.add_ons.title")}</Heading>
          <AddOns />
          <Sso />
          <Support />
          <Services />
        </div>
      )}
    </div>
  );
};

export default Features;
